import { Arrow as RadixTooltipArrow } from '@radix-ui/react-tooltip';
import styled from 'styled-components';

import { theme } from '../ui/theme';

export const Arrow = styled(RadixTooltipArrow)`
    fill: ${theme.colors.foreground.subtle};
`;
